import React, { createContext, useContext, useMemo, useState } from "react";
import { currentUser, isAuthenticated, logoutUser, setActiveUser } from "../hooks/useUserService";
import { IAppUser } from "../models/IAppUser";

type AuthContextValue = {
    userAuthenticated: boolean;
    user: IAppUser;
    login: (user: IAppUser) => void;
    logout: () => void;
    refresh: () => void;
};

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const [userAuthenticated, setUserAuthenticated] = useState<boolean>(isAuthenticated());
    const [user, setUser] = useState<IAppUser>(currentUser());

    const refresh = () => {
        setUser(currentUser());
        setUserAuthenticated(isAuthenticated());
    };

    const login = (user: IAppUser) => {
        if (user && user.Id && user.Id > 0) {
            setActiveUser(user);
            refresh();
        }
    };

    const logout = () => {
        logoutUser();
        refresh();
    };

    const value = useMemo(() => ({ userAuthenticated, user, login, logout, refresh }), [userAuthenticated, user]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used within AuthProvider");
    }
    return ctx;
}
